import { Outlet, createFileRoute, linkOptions } from '@tanstack/react-router'
import { t } from 'i18next'
import { List, Shield, Clock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Role } from 'types'

import SectionLayout from '../-components/section-layout/section-layout'

export const Route = createFileRoute('/app/settings')({
  component: RouteComponent,
})

const sidebarProps = {
  links: [
    {
      Icon: List,
      label: t('settings.file-types.title'),
      link: linkOptions({ to: '/app/settings/file-types' }),
      activeLink: '/app/settings/file-types',
    },
    {
      Icon: Shield,
      label: t('settings.trusted-devices.title'),
      link: linkOptions({ to: '/app/settings/trusted-devices' }),
      activeLink: '/app/settings/trusted-devices',
      requiredRole: Role.Admin,
    },
    {
      Icon: Clock,
      label: t('settings.import-runs.title'),
      link: linkOptions({ to: '/app/settings/import-runs' }),
      activeLink: '/app/settings/import-runs',
      requiredRole: Role.Admin,
    },
  ],
}

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <SectionLayout title={t('settings.title')} sidebarProps={sidebarProps}>
      <Outlet />
    </SectionLayout>
  )
}
